import type { FC } from 'react';
import styled from 'styled-components';
import { Icon, IconType } from '../../../Props/Icon/Icon';
import { NamedContentEntryText } from '../../../ContentEntryText/NamedContentEntryText';

type ActiveFilterPillProps = {
  filterCount: number;
  onClear: () => void;
};

export const ActiveFilterPill: FC<ActiveFilterPillProps> = ({ filterCount, onClear }) => {
  return (
    <Pill>
      <Icon width={16} height={16} icon={IconType.FILTER} fill="transparent" />
      <Text>
        <label>
          <NamedContentEntryText refKey="managerTeamBehaviors" container="span" subKey="activeFilter" />:
        </label>
        <b>{filterCount}</b>
      </Text>
      <Icon
        className="remove-filter"
        onClick={onClear}
        width={16}
        height={16}
        icon={IconType.TIMES}
        fill="transparent"
      />
    </Pill>
  );
};

const Pill = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${({ theme }) => theme.colors.prototype.secondary};
  border: 1px solid ${({ theme }) => theme.colors.prototype.border};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  padding: 4px 8px;
  margin-right: auto;
  > .remove-filter {
    cursor: pointer;
  }
`;

const Text = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
